import { createFeatureSelector, createSelector } from '@ngrx/store';
import { categoriesAdapter, categoriesFeature } from './categories-reducer';
import { CategoriesState } from './models';

const categoriesFeatureSelector = createFeatureSelector<CategoriesState>(categoriesFeature.name);

const { selectAll, selectEntities } = categoriesAdapter.getSelectors();

export const selectAllCategories = createSelector(categoriesFeatureSelector, selectAll);

export const selectUncategorized = createSelector(categoriesFeatureSelector, state => state.uncategorized);

export const selectAllCategoriesAndUncategorized = createSelector(
  selectAllCategories,
  selectUncategorized,
  (allCategories, uncategorized) => {
    if (!uncategorized) {
      return allCategories;
    }

    return [...allCategories, uncategorized];
  },
);

export const selectCategoriesEntities = createSelector(categoriesFeatureSelector, selectEntities);

export const selectHasAnyCreatedCategories = createSelector(selectAllCategories, categories =>
  Boolean(categories?.length),
);
export const selectHasNoCreatedCategories = createSelector(
  selectHasAnyCreatedCategories,
  hasAnyCategories => !hasAnyCategories,
);

export const selectCategoriesLoaded = createSelector(categoriesFeatureSelector, state => state.loaded);
